import { Component, OnDestroy, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../approval-of-traffic-organization-projects.routes';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { TrafficOrganizationProjectForm } from './forms/traffic-organization-project.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { DatePickerComponent } from '../../../../../../common/date-picker/date-picker.component';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-traffic-organization-project-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    CommonModule,
    DatePickerComponent,
    ParcelsCrudComponent,
    NgxMaskDirective
  ],
  providers: [TrafficOrganizationProjectForm],
  templateUrl: './traffic-organization-project-section.component.html'
})
export class TrafficOrganizationProjectSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private router: Router,
    public form: TrafficOrganizationProjectForm
  ) {
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(
        updateParcels({
          currentApp,
          payload: this.form.toWriteModel(),
          parcels: this.form.parcelsValues,
          successFnc: (applicationId: string) => {
            this.router.navigate(
              ['../zgody'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        })
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
